import styled, { useTheme } from "styled-components";
import { Link } from "react-router-dom";
import texmuIconLight from "../assets/Texmu-iOS-Default-1024x1024@1x.png";
import texmuIconDark from "../assets/Texmu-iOS-Dark-1024x1024@1x.png";

const FooterWrapper = styled.footer`
  border-top: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  margin-top: 120px;
`;

const FooterInner = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  padding: 28px 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const Logo = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 700;
`;
const LogoBadge = styled.span`
  width: 56px;
  height: 56px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const LogoImage = styled.img`
  width: 48px;
  height: 48px;
  display: block;
  border-radius: 12px;
`;

const LinkGroup = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  color: ${({ theme }) => theme.muted};
`;

const FooterLink = styled(Link)`
  color: ${({ theme }) => theme.muted};
  font-weight: 500;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.text};
  }
`;

const SmallPrint = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.small};
  color: ${({ theme }) => theme.muted};
`;

function Footer() {
  const theme = useTheme();
  const logoSrc = theme.name === "dark" ? texmuIconDark : texmuIconLight;
  return (
    <FooterWrapper>
      <FooterInner>
        <Logo to="/">
          <LogoBadge aria-hidden="true">
            <LogoImage src={logoSrc} alt="Texmu logo" />
          </LogoBadge>
          <span>Texmu</span>
        </Logo>
        <LinkGroup>
          <FooterLink to="/terms">Terms</FooterLink>
          <FooterLink to="/privacy">Privacy</FooterLink>
          <FooterLink to="/contact">Contact</FooterLink>
        </LinkGroup>
        <SmallPrint>© {new Date().getFullYear()} Texmu. All rights reserved.</SmallPrint>
      </FooterInner>
    </FooterWrapper>
  );
}

export default Footer;
